<template>
    <div>
        <nav-breadcrumb :menu="[{label: '审核预约' }]"/>
        <el-row>
            <el-col>
                <panel label="基本信息">
                <el-form :model="appointmentForm" :rules="appointmentFormRules" ref="appointmentForm" label-width="150px">
                    <el-row :gutter="10" class="bg-purple xamhtrpg">
                        <el-col :span="12">
                            <el-form-item label="客户姓名：">
                                {{appointmentForm.ba__customerName}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="身份证号码：" >
                                {{appointmentForm.ba__customerIC}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="手机号：" >
                                {{appointmentForm.ba__customerContactNo}}
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </panel>
            <panel label="分公司信息">
                <el-form :model="appointmentForm" :rules="appointmentFormRules" ref="appointmentForm" label-width="150px">
                    <el-row :gutter="10" class="bg-purple xamhtrpg">
                        <el-col :span="24">
                            <el-form-item label="分公司名称：">
                                {{appointmentForm.bo__branchName}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="地址：" >
                                {{appointmentForm.bo__province}}
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </panel>
            <panel label="预约信息">
                <el-form :model="appointmentForm" :rules="appointmentFormRules" ref="appointmentForm" label-width="150px">
                    <el-row :gutter="10" class="bg-purple xamhtrpg">
                        <el-col :span="12">
                            <el-form-item label="预约编号：">
                                {{appointmentForm.a__appointmentNo}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="预约状态：" >
                                {{('a__'+appointmentForm.a__appointmentStatus)|Status2CN}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="预约时间：" >
                                {{appointmentForm.a__createdDate|moment('YYYY-MM-DD HH:mm:ss')}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="预约室：" >
                                {{appointmentForm.r__roomName}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="省市：" >
                                {{appointmentForm.r__province}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="关联贷款：" >
                                {{appointmentForm.fi__transactionNo}}
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </panel>
                <panel label="审核流程">
                    <data-table
                        :table-data="{data: appointmentForm.progress||[]}"
                        :columns="approvalTableColumns"
                        :is-pagination-show="false"
                    />
                </panel>
                <panel label="">
                    <el-form :model="appointmentForm" :rules="appointmentFormRules" ref="approveForm" label-width="150px">
                        <el-row :gutter="10" class="bg-purple xamhtrpg">
                            <el-col :span="24">
                                <el-form-item label="审核意见：">
                                    <el-input type="textarea" v-model="appointmentForm.p__remarks" style="margin-bottom:10px;"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </panel>
            <div class="tr xzmt">
                <el-button type="primary" @click="onSubmit('approveForm')">审核通过</el-button>
                <el-button @click="rejected('approveForm')">否决</el-button>
            </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import {xmlBuildQuery} from "../../filters/CommonActions";
    import citysOptions from '../../utils/citys'
    import Status2CN from "../../filters/Status2CN";
    import moment from 'moment'
    export default {
        name: "ApproveBranchAppointment",
        data() {
            return {
                appointmentId:this.$route.query['appointmentId']||'',
                appointmentForm:{},
                appointmentFormRules:{},
                approvalTableColumns: [
                    {
                        label: '节点',
                        field: 'p__actionType',
                        formatter: (r,c,v)=> {
                            return Status2CN(v)
                        }
                    },
                    {
                        label: '操作人',
                        field: 'p__operator'
                    },
                    {
                        label: '操作时间',
                        field: 'p__createdDate',
                        formatter: (r,c,v)=>{
                            if(v)
                                return moment(v).format('YYYY-MM-DD HH:mm:ss')
                            else
                                return ''
                        }
                    },
                    {
                        label: '操作结果',
                        field: 'p__progress',
                        formatter: (r,c,v)=> {
                            if(v)
                                return Status2CN(v)
                            else
                                return ''
                        }
                    },
                    {
                        label: '操作备注',
                        field: 'p__remarks'
                    }
                ]
            }
        },
        filters: {

            Status2CN
        },
        mounted() {
            if(this.appointmentId){
                this.getData()

            }
        },
        watch:{
        },
        methods:{
            getData:function(){
                xhr.getBranchAppointment({
                        'a.appointmentId': this.appointmentId
                    },
                    res=> {
                        try{
                            if(res.data.status == 'success') {
                                this.appointmentForm = res.data.data
                                this.appointmentForm.bo__province =   (citysOptions.find(item=>item.code === Number(this.appointmentForm.bo__province))||{}).province+'/'+
                                    (citysOptions.find(item=>item.code === Number(this.appointmentForm.bo__city))||{}).city+'/'+
                                    (citysOptions.find(item=>item.code === Number(this.appointmentForm.bo__district))||{}).district
                                this.appointmentForm.r__province =
                                    (citysOptions.find(item=>item.code === Number(this.appointmentForm.r__city))||{}).city+'/'+
                                    (citysOptions.find(item=>item.code === Number(this.appointmentForm.r__district))||{}).district

                                let progress = []

                                progress.push({
                                    'p__actionType':'提交预约',
                                    'p__operator':this.appointmentForm.a__operator,
                                    'p__createdDate':this.appointmentForm.a__createdDate,
                                    'p__progress':'预约成功',
                                    'p__remarks':'',
                                })
                                this.appointmentForm.progress.forEach(item=>{
                                    if(item.p__actionType){
                                        progress.push({
                                            'p__actionType':item.p__actionType,
                                            'p__operator':item.p__operator,
                                            'p__createdDate':item.p__createdDate,
                                            'p__progress':item.p__progress,
                                            'p__remarks':item.p__remarks,
                                        })
                                    }
                                })
                                this.appointmentForm.progress = progress
                            }
                        }catch (e) {

                        }
                    })
            },


            onSubmit: function (formName) {
                let appointmentForm = this.appointmentForm
                this.$refs[formName].validate(valid=> {
                    if (valid) {
                        appointmentForm.p__checked = true
                        xhr.updateApproveBranchAppointment(appointmentForm, res=> {
                            try {
                                if (res.data.status == 'success') {
                                    this.$router.push({
                                        name: 'BranchAppointmentListView'
                                    })
                                }
                            } catch (e) {
                            }
                        })
                    }
                })
            },
            rejected: function (formName) {
                let appointmentForm = this.appointmentForm
                this.$refs[formName].validate(valid=> {
                    if (valid) {
                        appointmentForm.p__checked = true
                        xhr.rejectBranchAppointment(appointmentForm, res=> {
                            try {
                                if (res.data.status == 'success') {
                                    this.$router.push({
                                        name: 'BranchAppointmentListView'
                                    })
                                }
                            } catch (e) {
                            }
                        })
                    }
                })
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/branchoffice/ApproveBranchAppointment.vue